import api from './api';

class GuideService {
  create(data){
    return api.post('/user/register',data);
  }
  update(data){
    return api.post('/user/update',data);
  }
  updateInfo(data){
    return api.patch('/user/info',data);
  }
  updatePassword(data){
    return api.patch('/user/password',data);
  }
 
  getPublicContent() {
    return api.get('/test/all');
  }

  getUserBoard() {
    return api.get('/test/user');
  }

  getModeratorBoard() {
    return api.get('/test/mod');
  }

  getAdminBoard() {
    return api.get('/test/admin');
  }

  getDataPage(params) {
      return api.get('/user/list-guide',{params:params});
  }
  getList(params){
    return this.getDataPage(params);
  }
  getStatistics(){
    return api
      .get("/user/statistics-guide")
      .then((response) => {
          return response;
      });
  }
  get(params){
    return api.get('/user/detail',{params:params})
  }

  destroyUser(data) {
    return api
    .delete("/user/"+data)
    .then((response) => {
        return response;
    });
  }

}

export default new GuideService();
